export const PHONE = 'phone';
export const J_USERNAME = 'j_username';
export const PASSWORD = 'password';
export const J_PASSWORD = 'j_password';
export const CAPTCHA = 'captcha';
export const J_CAPTCHA = 'j_captcha_response';
export const USER_LOGIN_COUNTRY_ID = 'user_login_country_id';

export const DEFAULT_LANG = 'en';
export const DEFAULT_COUNTRY = 'gb';

export const USER_UUID = 'user_uuid';
export const TOKEN_ID = 'token_id';
export const USER_NAME = 'user_name';
export const SUCCESS = 'SUCCESS';
export const INFO = 'INFO';
export const ERROR = 'ERROR';
export const SUCCESS_TOAST = 'SUCCESS_TOAST';
export const CHANGE_IDENT_STATUS = 'CHANGE_IDENT_STATUS';
export const ERROR_TOAST = 'ERROR_TOAST';

export const BONUS = 'BONUS';
export const DC = 'DC';
export const EXTERNAL = 'EXTERNAL';

export const SPRING_REDIRECT_HEADER = 'spring-redirect-url';
export const LOCATION = 'location';
export const SET_COOKIES = 'set-cookie';
export const SESSION = 'SESSION';
export const LOCAL_INSTANCE_HOST_ID = 'local-instance-host-id';
export const USER_THEME = 'user_theme';
export const USER_THEME_LIGHT = 'light';
export const USER_THEME_DARK = 'dark';
export const USER_THEME_SYSTEM = 'system';
export const IS_SYSTEM_THEME = 'is_system_theme';

//Delivery
export const DELIVERY = 'delivery';
export const DELIVERY_BANK_CARD = 'BANK_CARD';
export const DELIVERY_BANK_ACCOUNT = 'BANK_ACCOUNT';

export const DELIVERY_SEPA = 'SEPA';
export const DELIVERY_REMITEE = 'REMITEE';
export const DELIVERY_SWIFT = 'SWIFT';
export const DELIVERY_CASH = 'CASH';
export const DELIVERY_CASH_UNITELLER = 'CASH_UNITELLER';
export const DELIVERY_HOME = 'HOME_DELIVERY';
export const DELIVERY_WALLET = 'WALLET';
export const DELIVERY_VIA_PHONE_NUMBER = 'CARD_VIA_PHONE';
export const DELIVERY_ALIPAY = 'ALIPAY';
export const DELIVERY_VISA_BANK_CARD = 'VISA_BANK_CARD';
export const DELIVERY_UNIONPAY_BANK_CARD = 'UNIONPAY_CARD';
export const DELIVERY_UNITELLER_MASTERCARD_BANK_CARD = 'UNITELLER_MASTERCARD_BANK_CARD';
export const DELIVERY_MOBILE = 'MOBILE';
export const DELIVERY_UPI = 'UPI';
export const DELIVERY_INTERAC = 'INTERAC';
export const DELIVERY_PEOPLE_TRUST_INTERAC = 'PEOPLE_TRUST_INTERAC';
export const DELIVERY_CONTACT = 'CONTACT';
export const DELIVERY_WECHAT = 'WECHAT';
export const DELIVERY_LIBRE_PAYSEND_LIVE = 'LIBRE_PAYSEND_LIVE';

//PaymentMethod
export const PAYMENT = 'payment';
export const PAYMENT_BONUS = 'BONUS';
export const PAYMENT_BANK_CARD = 'BANK_CARD';
export const PAYMENT_BANK_CARD_110 = 'BANK_CARD_110';
export const PAYMENT_BANK_ACCOUNT = 'BANK_ACCOUNT';
export const PAYMENT_USA_BANK_ACCOUNT = 'USA_BANK_ACCOUNT';
export const PAYMENT_GLOBAL_ACCOUNT = 'GT_GLOBAL_ACCOUNT';
export const PAYMENT_PAYPAL = 'PAYPAL';
export const PAYMENT_GOOGLE_PAY = 'GOOGLE_PAY';
export const PAYMENT_APPLE_PAY = 'APPLE_PAY';
export const PAYMENT_INTERAC = 'INTERAC';
export const PAYMENT_PEOPLE_TRUST_INTERAC = 'PEOPLE_TRUST_INTERAC';
export const PAYMENT_FLINKS = 'FLINKS';
export const PAYMENT_TRUSTLY = 'TRUSTLY';
export const PAYMENT_TINK = 'TINK';
export const PAYMENT_ACH = 'ACH';
export const PAYMENT_SOFORT = 'SOFORT';
export const PAYMENT_KLARNA = 'KLARNA';
export const PAYMENT_GIROPAY = 'GIROPAY';
export const PAYMENT_IDEAL = 'IDEAL';
export const PAYMENT_BLIK = 'BLIK';
export const PAYMENT_MBWAY = 'MBWAY';
export const PAYMENT_MYBANK = 'MYBANK';
export const PAYMENT_MODULR = 'MODULR';
export const PAYMENT_PLAID = 'PLAID';
export const PAYMENT_EPS = 'EPS';
export const PAYMENT_LEAN = 'LEAN';
export const PAYMENT_OFAKIM = 'OFAKIM';

// Transfer statuses
export const PROCESSING = 'PROCESSING';
export const WARNING = 'WARNING';
export const FINAL_OK = 'FINAL_OK';
export const FINAL_FAIL = 'FINAL_FAIL';

//Class names
export const ACTIVE = 'active';

//Action Types
export const SEND_TO = 'SEND_TO';
export const SEND_FROM = 'SEND_FROM';
export const CREATE_REQUEST = 'CREATE_REQUEST';

//Chat

export const SEND = 'SEND';
export const REQUEST = 'REQUEST';
export const PROFILE = 'PROFILE';
export const HELP = 'HELP';

export const OBJECT_TYPE_CONFIRM_CARD_WITH_AMOUNT = 'DC_LINK_FOR_TXN_CONFIRM';
export const OBJECT_TYPE_PLUM_FROM_DEALER_CONFIRM = 'PLUM_FROM_DEALER_CONFIRM';

//Transaction types
export const CARD = 'CARD';
export const GA_CARD = 'GA_CARD';
export const GA_ACCOUNT = 'GA_ACCOUNT';
export const BASIC = 'BASIC';
export const WALLET = 'WALLET';
export const OUT_GOING_ML = 'OUT_GOING_ML';
export const PUSH = 'PUSH';
export const PS_BONUS = 'PS_BONUS';
export const ACCOUNT = 'ACCOUNT';
export const ACH_ACCOUNT = 'ACH';
export const LEAN_ACCOUNT = 'LEAN';
export const PS_BONUS_INCOMING = 'PS_BONUS_INCOMING';

export const INCOMING = 'incoming';
export const OUTOGOING = 'outgoing';

// Provider category
export const PROVIDER_ID_FROM_P2P = 7;
export const PROVIDER_ID_TO_P2P = 99;

export const CATEGORY_TRANSFER_TO_BANK_ACCOUNT = -13;
export const CATEGORY_TRANSFER_VIA_SWIFT = -45;
export const CATEGORY_TRANSFER_TO_WALLET = -17;
export const CATEGORY_TRANSFER_TO_CARD = -10;
export const CATEGORY_TRANSFER_TO_VISA_CARD = -56;
export const CATEGORY_TRANSFER_TO_UNIONPAY_CARD = -150;
export const CATEGORY_TRANSFER_TO_UNITELLER_MASTER_CARD = -80;
export const CATEGORY_TRANSFER_FROM_CARD = -10;
export const CATEGORY_TRANSFER_FROM_CARD_110 = -110;
export const CATEGORY_TRANSFER_FROM_BANK_ACCOUNT = -16;
export const CATEGORY_TRANSFER_FROM_USA_BANK_ACCOUNT = -100;
export const CATEGORY_TRANSFER_FROM_BANK_OFAKIM = -57;
export const CATEGORY_TRANSFER_FROM_APPLE_PAY = -21;
export const CATEGORY_TRANSFER_FROM_APPLE_PAY_SV = -60;
export const CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA_DAC = -65;
export const CATEGORY_TRANSFER_FROM_APPLE_PAY_US = -67;
export const CATEGORY_TRANSFER_FROM_APPLE_PAY_EEA = -69;
export const CATEGORY_TRANSFER_FROM_GOOGLE_PAY = -20;
export const CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA = -61;
export const CATEGORY_TRANSFER_FROM_GOOGLE_PAY_US = -64;
export const CATEGORY_TRANSFER_FROM_GOOGLE_PAY_EEA_DAC = -66;
export const CATEGORY_TRANSFER_FROM_GOOGLE_PAY_SV = -68;
export const CATEGORY_TRANSFER_TO_ALIPAY = -18;
export const CATEGORY_TRANSFER_TO_INTERAC = -32;
export const CATEGORY_TRANSFER_TO_PEOPLE_TRUST_INTERAC = -105;
export const CATEGORY_TRANSFER_FROM_INTERAC = -32;
export const CATEGORY_TRANSFER_FROM_PEOPLE_TRUST_INTERAC = -105;
export const CATEGORY_TRANSFER_FROM_PAYPAL = -125;
export const CATEGORY_TRANSFER_TO_LIBRE = -53;
export const ACCOUNT_LENGTH = 4;
export const CATEGORY_TRANSFER_TO_UPI = -26;
export const CATEGORY_TRANSFER_TO_CASH = -31;
export const CATEGORY_TRANSFER_TO_HOME_DELIVERY = -38;
export const CATEGORY_TRANSFER_TO_CASH_UNITELLER = -70;

export const CATEGORY_TRANSFER_TO_SEPA = -71;
export const CATEGORY_TRANSFER_TO_REMITEE = -72;
export const CATEGORY_ACCOUNT_DEBIT_VIA_MODULR = -34;
export const CATEGORY_TRANSFER_FROM_TRUSTLY = -36;
export const CATEGORY_TRANSFER_FROM_TINK = -145;
export const CATEGORY_ACCOUNT_DEBIT_VIA_PLAID = -35;
export const CATEGORY_ACCOUNT_DEBIT_VIA_IRELAND_PLAID = -90;
export const CATEGORY_TRANSFER_FROM_FLINKS = -39;
export const CATEGORY_TRANSFER_FROM_ACH = -41;
export const CATEGORY_TRANSFER_FROM_SOFORT = -43;
export const CATEGORY_TRANSFER_FROM_KLARNA = -130;
export const CATEGORY_TRANSFER_TO_WECHAT = -42;
export const CATEGORY_TRANSFER_TO_CARD_VIA_PHONE_NUMBER = -40;
export const CATEGORY_TRANSFER_FROM_LEAN = -47;
export const CATEGORY_TRANSFER_FROM_MYBANK = -46;
export const CATEGORY_TRANSFER_FROM_GIROPAY = -49;
export const CATEGORY_TRANSFER_FROM_GLOBAL_ACCOUNT = -30;
export const CATEGORY_TRANSFER_TO_GLOBAL_ACCOUNT = -30;
export const CATEGORY_TRANSFER_FROM_IDEAL = -44;
export const CATEGORY_TRANSFER_FROM_BLIK = -52;
export const CATEGORY_TRANSFER_FROM_MBWAY = -54;
export const CATEGORY_TRANSFER_FROM_EPS = -48;
export const CATEGORY_TRANSFER_FROM_BONUS = -50;

export const STATUS_OK = 90;
export const STATUS_PENDING = 10;
export const STATUS_INPROGRESS = 50;
export const STATUS_SENDING_70 = 70;
export const STATUS_SENDING_INTERAC = 80;
export const STATUS_NEED_TO_PASS_KYC = 83;

//Doc status
export const IDENT_PROCESS = 'IDENT_PROCESS';
export const IDENT_REJECTED = 'IDENT_REJECTED';
export const IDENT_INCORRECT = 'IDENT_INCORRECT';
export const NO_IDENT = 'NO_IDENT';

//Limits
export const THREE_MONTHLY_LIMITS = 'THREE_MONTHLY';
export const LIMIT_TYPE_COUNT = 'COUNT';
export const BUSINESS_LIMIT = 'business';
export const VALID_ERROR = 'site.js.validation.valid.error';
export const REQ_ERROR = 'site.js.validation.req.error';
export const INVALID_CARD_ERROR = 'site.js.validation.mod10.error';

export const AML_LEVEL_BASIC = 0;
export const AML_LEVEL_STANDARD = 1;
export const AML_LEVEL_ADVANCE = 2;
export const AML_LEVEL_ULTIMATE = 3;

//payee
export const PERSONAL = 'PERSONAL';
export const NOT_MATCHED = 'NOT_MATCHED';
export const MATCHED = 'MATCHED';

// ga statement
export const LIST_SCREEN = 'list';
export const PERIOD_SCREEN = 'period';
export const SUCCESS_SCREEN = 'success';
export const THIS_MONTH = 'this_month';
export const LAST_MONTH = 'last_month';
export const SELECT_PERIOD = 'select_period';
export const BAD_DATE = 'bad_date';

// transfer statement
export const STATEMENT_LIST_SCREEN = 'statement_list_screen';
export const SELECT_PERIOD_SCREEN = 'select_period_screen';
export const EMAIL_SCREEN = 'email_screen';
export const STATEMENT_SUCCESS_SCREEN = 'statement_success_screen';
export const DATE_IN_FUTURE_ERROR = 'site.balance.account.statement.date.in.future.error';
export const START_AFTER_END_ERROR = 'site.balance.account.statement.start.date.after.end.error';
export const END_BEFORE_START_ERROR = 'site.balance.account.statement.end.date.before.start.error';
export const BEFORE_ACCOUNT_DATE_ERROR = 'site.balance.account.statement.date.earlier.error';
export const MAX_STATEMENT_VALID_ERROR = 'site.js.validation.max.statement.valid.error';

export const COMMON_AMOUNT_ISSUE = 'COMMON_AMOUNT_ISSUE';
export const MIN_AMOUNT_ISSUE = 'MIN_AMOUNT_ISSUE';
export const MAX_AMOUNT_ISSUE = 'MAX_AMOUNT_ISSUE';
export const MAX_AMOUNT_BONUS_ISSUE = 'MAX_AMOUNT_BONUS_ISSUE';
export const MAX_AMOUNT_BONUS_LIMIT_ISSUE = 'MAX_AMOUNT_BONUS_LIMIT_ISSUE';
export const MULTIPLE_AMOUNT_ISSUE = 'MULTIPLE_AMOUNT_ISSUE';
export const BALANCE_ISSUE = 'BALANCE_ISSUE';
export const BLOCK_THREE_MONTH_LIMIT_ISSUE = 'BLOCK_THREE_MONTH_LIMIT_ISSUE';
export const ADDITIONAL_LIMIT_ISSUE = 'ADDITIONAL_LIMIT_ISSUE';
export const PROFILE_LIMIT_ISSUE = 'PROFILE_LIMIT_ISSUE';

export const USA_PROFILE_LIMIT_ISSUE = 'USA_PROFILE_LIMIT_ISSUE';

// Recipient type
export const RECIPIENT_TYPE_SELF = 'self';
export const RECIPIENT_TYPE_OTHER = 'other';
export const RECIPIENT_TYPE_BUSINESS = 'business';
export const TYPE = 'type';

// Fraud block
export const SOFT_BLOCK = 'SOFT_BLOCK';
export const HARD_BLOCK = 'HARD_BLOCK';

export const XSS_FILTER_OPTIONS = {
    whiteList: {
        a: ['href', 'title', 'target', 'class', 'style', 'data-modal-id', 'data-action-id'],
        div: ['class', 'style'],
        article: ['class', 'style'],
        blockquote: ['class', 'style'],
        span: ['class', 'style'],
        i: ['class', 'style'],
        p: ['class', 'style'],
        br: ['class', 'style'],
        b: ['class', 'style'],
        ul: ['class', 'style'],
        ol: ['class', 'style', 'start'],
        li: ['class', 'style'],
        strong: ['class', 'style'],
        h1: ['class', 'style'],
        h2: ['class', 'style'],
        h3: ['class', 'style'],
        h4: ['class', 'style'],
        h5: ['class', 'style'],
        h6: ['class', 'style'],
        em: ['class', 'style'],
        ins: ['class', 'style'],
        sub: ['class', 'style'],
        sup: ['class', 'style'],
        img: ['class', 'style', 'src'],
        iframe: ['class', 'style', 'src'],
        u: ['class', 'style'],
        figure: ['class', 'style'],
        table: ['class', 'style'],
        thead: ['class', 'style'],
        tbody: ['class', 'style'],
        tr: ['class', 'style'],
        th: ['class', 'style'],
        td: ['class', 'style'],
        hr: ['class', 'style'],
    },
};

// Cloud flare
export const CLOUD_FLARE_SUCCESS_MESSAGE = 'Challenge solved';
export const CLOUD_FLARE_FAILED_MESSAGE = 'Challenge failed';

export const XSS_HARSH_FILTER_OPTIONS = {
    whiteList: {
        span: ['class', 'style'],
        i: ['class', 'style'],
        p: ['class', 'style'],
        br: ['class', 'style'],
        b: ['class', 'style'],
        ul: ['class', 'style'],
        ol: ['class', 'style', 'start'],
        li: ['class', 'style'],
        strong: ['class', 'style'],
    },
    stripIgnoreTag: true,
};

// Additional profile fields
export const INFO_SCREEN = 'info_screen';
export const FIELDS_SCREEN = 'fields_screen';
export const SPINNER = 'spinner';
